export default __webpack_public_path__ + "static/media/ASD.172a8f7d.jpg";